import { parseSpotifyUri } from '../utils';

const SpotifyOpenLink = ({ uri }) => {
    const { type, id } = parseSpotifyUri(uri);
    return (
        <a href={`https://open.spotify.com/${type}/${id}`} target="_blank" rel="noreferrer noopener">
            {uri}
        </a>
    );
};
export default SpotifyOpenLink;
